<!-- https://vuetifyjs.com/en/api/v-data-table/#api-props  -->
<!-- This is a data table with dynamically generated headers using props to change url -->
<template>
    <v-row>
        <MaterialfyColorCard :cardShowInnerText="false" :cardShowDivider="true" :cardShowActions="false"
            cardColor="secondary">
            <template v-slot:crdInner>
                <materialfy-header-card cardTitle='Ordenes' text="Here is a subtitle for this table" cardMinWidth="100"
                    :cardShowInnerList="false" :cardShowDivider="false">
                    <template v-slot:crdInner>
                        <div v-if="!isAutomatic">
                            <MaterialfyColorCard :cardShowInnerText="false" :cardShowDivider="true"
                                :cardShowActions="false" cardColor="secondary" cardMinWidth="200">
                                <template v-slot:crdInner>
                                    <v-row justify="center">
                                        <v-card-title class="text-h5">{{ titleOrders }}</v-card-title>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="1" xs="0" sm="0" md="1" class="flex-grow-0 flex-shrink-0"></v-col>
                                        <v-col cols="10" xs="0" sm="0" md="10" class="flex-grow-0 flex-shrink-0">
                                            <br>
                                            <v-row justify="center" no-gutters>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title class="text-center">Fecha
                                                            Inicio:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{
                                                            initDate
                                                            }}</v-list-item-title>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title class="text-center">Saldo
                                                            Bot:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{
                                                            available
                                                            }}</v-list-item-title>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <br>
                                            <vDivider></vDivider>
                                            <br>
                                            <v-row justify="center" no-gutters>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title
                                                            class="text-center">Beneficios:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{
                                                            profits
                                                            }}</v-list-item-title>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title
                                                            class="text-center">Comisiones:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{ fees
                                                            }}</v-list-item-title>
                                                    </v-row>

                                                </v-col>
                                            </v-row>
                                            <br>
                                            <vDivider></vDivider>
                                            <br>
                                            <v-row v-show="isActive" no-gutters>
                                                <v-col cols="4" xs="0" sm="0" md="4"
                                                    class="flex-grow-0 flex-shrink-0"></v-col>
                                                <v-col cols="4" xs="12" sm="12" md="4"
                                                    class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-card>
                                                            <v-btn :color="colors" @click="statusBot(item, 'sendStatus')">{{
                                                                msgBtn }}</v-btn>
                                                        </v-card>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <br>
                                        </v-col>
                                    </v-row>
                                    <!-- <MaterialfyColorCard cardInnerText="$$$$$$$ emoji" :cardShowDivider="false"
                                        :cardShowActions="false">
                                        <template v-slot:crdInner>
                                            <materialfy-apex-y-axis ref="chart" />
                                        </template>
</MaterialfyColorCard> -->

                                </template>

                            </MaterialfyColorCard>
                            <v-data-table :headers="headers" :items="items" sort-by="id"
                                class="elevation-1 primary mx-auto" :mobile-breakpoint="0">
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" dark v-on="on"
                                                @click="handleClick(item, 'orders')">mdi-play</v-icon>
                                        </template>
                                        <span>Ordenes</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" dark v-on="on"
                                                @click="handleClick(item, 'update')">mdi-content-save-edit-outline</v-icon>
                                        </template>
                                        <span>Actualizar</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" dark v-on="on"
                                                @click="handleClick(item, 'delete')">mdi-trash-can-outline</v-icon>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </div>
                        <div v-if="isAutomatic">
                            <MaterialfyColorCard :cardShowInnerText="false" :cardShowDivider="true"
                                :cardShowActions="false" cardColor="secondary" cardMinWidth="200">
                                <template v-slot:crdInner>
                                    <v-row justify="center">
                                        <v-card-title class="text-h5">{{ titleOrders }}</v-card-title>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="0" xs="0" sm="0" md="2" class="flex-grow-0 flex-shrink-0"></v-col>
                                        <v-col cols="12" xs="0" sm="0" md="8" class="flex-grow-0 flex-shrink-0">
                                            <br>
                                            <v-row justify="center" no-gutters>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title class="text-center">Fecha
                                                            Inicio:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{
                                                            initDate
                                                            }}</v-list-item-title>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title class="text-center">Saldo
                                                            Bot:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{
                                                            available
                                                            }}</v-list-item-title>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <br>
                                            <vDivider></vDivider>
                                            <br>
                                            <v-row justify="center" no-gutters>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title
                                                            class="text-center">Beneficios:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{
                                                            profits
                                                            }}</v-list-item-title>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-list-item-title
                                                            class="text-center">Comisiones:</v-list-item-title>
                                                        <v-list-item-title class="text-center">{{ fees
                                                            }}</v-list-item-title>
                                                    </v-row>

                                                </v-col>
                                            </v-row>
                                            <br>
                                            <vDivider></vDivider>
                                            <br>
                                            <v-row v-show="isActive" no-gutters>
                                                <v-col cols="4" xs="0" sm="0" md="4"
                                                    class="flex-grow-0 flex-shrink-0"></v-col>
                                                <v-col cols="4" xs="12" sm="12" md="4"
                                                    class="flex-grow-0 flex-shrink-0">
                                                    <v-row no-gutters justify="center">
                                                        <v-card>
                                                            <v-btn :color="colors" @click="statusBot(item, 'sendStatus')">{{
                                                                msgBtn }}</v-btn>
                                                        </v-card>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <br>
                                        </v-col>
                                    </v-row>
                                    <!-- Chart -->
                                    <!-- <MaterialfyColorCard cardInnerText="$$$$$$$ emoji" :cardShowDivider="false"
                                        :cardShowActions="false">
                                        <template v-slot:crdInner>
                                            <MaterialfyChartBots ref="chart" />
                                        </template>
    </MaterialfyColorCard> -->
                                </template>

                            </MaterialfyColorCard>
                            <v-data-table :headers="headersAutoBot" :items="items" sort-by="id"
                                class="elevation-1 primary mx-auto" :mobile-breakpoint="0">
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" dark v-on="on"
                                                @click="handleClick(item, 'orders')">mdi-play</v-icon>
                                        </template>
                                        <span>Ordenes</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" dark v-on="on"
                                                @click="handleClick(item, 'update')">mdi-content-save-edit-outline</v-icon>
                                        </template>
                                        <span>Actualizar</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" dark v-on="on"
                                                @click="handleClick(item, 'delete')">mdi-trash-can-outline</v-icon>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </div>
                    </template>
                    <template #crdActions>
                        <!-- <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <v-row no-gutters justify="center">
                            <v-btn @click="toHistoric">HISTORICO</v-btn>
                        </v-row>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br> -->
                    </template>
                </materialfy-header-card>
            </template>
        </MaterialfyColorCard>
    </v-row>
</template>

<script>
import UserService from '@/services/user.service'
// import { genericApi } from "../../plugins/axios"

export default {
    props: {
        showHeader: {
            default: true
        },
        activateBreakpoint: {
            default: 0
        }
    },
    data: () => ({
        idBot: '',
        // bot: new Bot(),
        // Table
        headers: [
            // { text: 'Tipo', value: 'typeCompra', align: 'center' },
            { text: 'Fecha Compra', value: 'fechaCompra', align: 'center' },
            // { text: 'Cantidad Comprado', value: 'amountCompra', align: 'center' },
            { text: 'Precio Compra', value: 'precioCompra', align: 'center' },
            // { text: 'Tipo', value: 'typeVenta', align: 'center' },
            { text: 'Fecha Venta', value: 'fechaVenta', align: 'center' },
            // { text: 'Cantidad Vendido', value: 'amountVenta', align: 'center' },
            { text: 'Precio Venta', value: 'precioVenta', align: 'center' },
            { text: 'Volumen', value: 'amountCompra', align: 'center' },
            { text: 'Beneficio', value: 'profitsTrade', align: 'center' },
            { text: 'Comision', value: 'comisionesTrade', align: 'center' }
        ],
        items: [],
        headersAutoBot: [
            { text: 'Par', value: 'symbol', align: 'center' },
            { text: 'Fecha Compra', value: 'fechaCompra', align: 'center' },
            // { text: 'Cantidad Comprado', value: 'amountCompra', align: 'center' },
            { text: 'Precio Compra', value: 'precioCompra', align: 'center' },
            // { text: 'Tipo', value: 'typeVenta', align: 'center' },
            { text: 'Fecha Venta', value: 'fechaVenta', align: 'center' },
            // { text: 'Cantidad Vendido', value: 'amountVenta', align: 'center' },
            { text: 'Precio Venta', value: 'precioVenta', align: 'center' },
            { text: 'Volumen', value: 'amountCompra', align: 'center' },
            { text: 'Beneficio', value: 'profitsTrade', align: 'center' },
            { text: 'Comision', value: 'comisionesTrade', align: 'center' }
        ],
        itemsAutoBot: [],
        // right: null,
        search: '',
        colors: 'success',
        msgBtn: '',
        isAdmin: '',
        isAutomatic: false,

        titleOrders: "",
        pair1: "",
        pair2: "",
        initDate: "",
        available: '',
        market1: '',
        startPrice: "",
        currentPrice: "",
        profits: "",
        fees: "",
        start: false,
        isOpenDialog: false,
        isActive: true,
        isLoaded: false,
    }),

    computed: {
        itemsWithIndex() {
            return this.items.map((item, index) => ({ ...item, index: index }))
        }
    },
    // called when page is created before dom to load data from api
    created() { },
    mounted() {
        // // Declare a variable
        // let isUndefined;
        // // Condition to check variable is defined or not
        // // console.log(this.$store.state.auth.user.roles[0])
        // if (typeof this.$route.params.idBot === 'undefined') {
        //     isUndefined = true;
        // } else {
        //     isUndefined = false;
        // }
        // if (this.$route.params.idBot !== null && !isUndefined) {
        //     this.idBot = this.$route.params.idBot
        //     UserService.getBot(this.idBot).then(
        //         response => {
        //             this.bot = response.data
        //             // console.log(this.bot)
        //             this.isAutomatic = this.bot.automatico

        //             this.initData(this.idBot, false, this.bot.active)
        //             // this.$refs.ordersData.initData(this.idBot, false, this.bot.active)
        //             this.getOrders()
        //         },
        //         error => {
        //             this.content =
        //                 (error.response &&
        //                     error.response.data &&
        //                     error.response.data.message) ||
        //                 error.message ||
        //                 error.toString();

        //             if (error.response && error.response.status === 403 || error.response.status === 401) {
        //                 this.$store
        //                     .dispatch('logout', this.user) //calls the login action and passes login info
        //                     .then(() => this.$router.push('/')) //redirect to dash after login
        //                     .catch((err) => {
        //                         console.log(err)
        //                         this.snackbar = true //shows error on wrong pass
        //                     })
        //             }
        //         }
        //     );
        // }
    },

    methods: {
        // getOrders() {
        //     UserService.getTradesBot(this.idBot).then(
        //         response => {
        //             // console.log(response.data)
        //             this.items = response.data;
        //         },
        //         error => {
        //             this.content =
        //                 (error.response && error.response.data && error.response.data.message) ||
        //                 error.message ||
        //                 error.toString();
        //             if (error.response && error.response.status === 403 || error.response.status === 401) {
        //                 this.$store
        //                     .dispatch('logout', this.user) //calls the login action and passes login info
        //                     .then(() => this.$router.push('/')) //redirect to dash after login
        //                     .catch((err) => {
        //                         console.log(err)
        //                         this.snackbar = true //shows error on wrong pass
        //                     })
        //             }
        //         }
        //     );
        // },
        // initData(value, isAdmin, isActive) {
        //     this.idBot = value
        //     this.isAdmin = isAdmin
        //     this.isActive = isActive
        //     UserService.getStatusBot(this.idBot).then(
        //         response => {
        //             // console.log(response.data)
        //             if (response.data === 'NOT INIT') {
        //                 UserService.getBot(this.idBot).then(
        //                     response => {
        //                         // console.log(response.data)
        //                         this.bot = response.data
        //                         this.isAutomatic = this.bot.automatico
        //                         this.start = false
        //                         this.msgBtn = 'START'
        //                         this.colors = 'success'
        //                     }
        //                 );
        //             } else {
        //                 this.loadData(response.data, isAdmin);
        //             }
        //         },
        //         error => {
        //             this.content =
        //                 (error.response && error.response.data && error.response.data.message) ||
        //                 error.message ||
        //                 error.toString();
        //             if (error.response && error.response.status === 403 || error.response.status === 401) {
        //                 this.$store
        //                     .dispatch('logout', this.user) //calls the login action and passes login info
        //                     .then(() => this.$router.push('/')) //redirect to dash after login
        //                     .catch((err) => {
        //                         console.log(err)
        //                         this.snackbar = true //shows error on wrong pass
        //                     })
        //             }
        //         }
        //     );
        // },
        // loadData(data) {
        //     if (data !== 'NOT INIT') {
        //         // console.log(data.bot.pair)
        //         this.bot = data.bot;
        //         this.isAutomatic = this.bot.automatico

        //         // this.$refs.chart.chartOptions.xaxis.categories = ['Enero', 'Febrero', 'Marzo', 'Abril',
        //         //     'Mayo', 'Junio', 'Julio', 'Agosto',
        //         //     'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

        //         // 
        //         // this.$refs.chart.loadDataSets(this.bot.id, isAdmin)
        //         this.loadUserChart(this.idBot)
        //         this.titleOrders = this.bot.pair;
        //         let arrayPairs = this.bot.pair.split("-");
        //         this.pair1 = arrayPairs[0];
        //         this.pair2 = arrayPairs[1];
        //         this.initDate = data.start_time
        //         this.available = data.available
        //         this.market1 = data.market1_balance
        //         this.startPrice = data.start_price
        //         this.currentPrice = data.currentPrice
        //         this.fees = data.fees
        //         this.profits = data.profits
        //         if (this.bot.started === false) {
        //             this.start = false
        //             this.msgBtn = 'START'
        //             this.colors = 'success'
        //         } else {
        //             this.start = true
        //             this.msgBtn = 'STOP'
        //             this.colors = 'error'
        //         }
        //     } else {
        //         this.start = false
        //         this.msgBtn = 'START'
        //         this.colors = 'success'
        //     }
        // },
        statusBot({ item, action}) {
            console.log(item)
            console.log(action)
            this.$emit('action-status', { item, action });
            // if (this.start === false) {
            //     this.start = true
            //     this.msgBtn = 'STOP'
            //     this.colors = 'error'
            //     // Iniciar bot
            //     this.sendStatus(true)
            // } else {
            //     this.start = false
            //     this.msgBtn = 'START'
            //     this.colors = 'success'
            //     // Parar bot
            //     this.pauseBot(false)
            // }
        },
        // sendStatus(status) {
        //     this.message = ''
        //     this.submitted = true
        //     this.bot.started = status
        //     if (this.isAutomatic) {
        //         UserService.postStatusBotAuto(this.bot).then(
        //             response => {
        //                 this.idBot = response.bot.id
        //                 this.initData(this.idBot, this.isAdmin, this.isActive)
        //                 setTimeout(() => (this.responseChangeStartedBot('success', 'INICIAR BOT', 'Bot iniciado!!!')), 1000)
        //             },
        //             error => {
        //                 this.content =
        //                     (error.response && error.response.data && error.response.data.message) ||
        //                     error.message ||
        //                     error.toString()
        //                 setTimeout(() => (this.responseChangeStartedBot('error', 'INICIAR BOT', this.msgError)), 1000)
        //             }
        //         )
        //     } else {
        //         UserService.postStatusBot(this.bot).then(
        //             response => {
        //                 this.idBot = response.bot.id
        //                 this.initData(this.idBot, this.isAdmin, this.isActive)
        //                 setTimeout(() => (this.responseChangeStartedBot('success', 'INICIAR BOT', 'Bot iniciado!!!')), 1000)
        //             },
        //             error => {
        //                 this.content =
        //                     (error.response && error.response.data && error.response.data.message) ||
        //                     error.message ||
        //                     error.toString()
        //                 setTimeout(() => (this.responseChangeStartedBot('error', 'INICIAR BOT', this.msgError)), 1000)
        //             }
        //         )
        //     }

        // },
        // pauseBot(status) {
        //     this.message = ''
        //     this.submitted = true
        //     this.bot.started = status
        //     UserService.pauseBot(this.bot).then(
        //         response => {
        //             this.idBot = response.id
        //             this.initData(this.idBot, this.isAdmin, this.isActive)
        //             setTimeout(() => (this.responseChangeStartedBot('success', 'PARAR BOT', 'Bot parado!!!')), 1000)
        //         },
        //         error => {
        //             this.content =
        //                 (error.response && error.response.data && error.response.data.message) ||
        //                 error.message ||
        //                 error.toString()
        //             setTimeout(() => (this.responseChangeStartedBot('error', 'PARAR BOT', this.msgError)), 1000)
        //         }
        //     );
        // },
        // responseChangeStartedBot(response, title, msg) {
        //     this.top = true;
        //     this.bottom = true;
        //     this.left = false;
        //     this.right = false;
        //     this.msg_toast = msg
        //     this.snackbar = true;

        //     if (response === 'success') {
        //         this.color = 'success'
        //         this.successful = true
        //     } else {
        //         this.color = 'error'
        //         this.successful = false
        //     }

        //     // this.$refs.dialogMessages.openModal()
        //     // this.$refs.dialogMessages.component = 'CHANGE STARTED BOT'
        //     // this.$refs.dialogMessages.tituloDialog = title
        //     // this.$refs.dialogMessages.msgError = msg
        //     // this.$refs.dialogMessages.isShow = true
        //     // if (response === 'success') {
        //     //     this.$refs.dialogMessages.types = 'success'
        //     //     this.successful = true
        //     // } else {
        //     //     this.$refs.dialogMessages.types = 'error'
        //     //     this.successful = false
        //     // }
        // },
        loadUserChart(value) {

            UserService.getChartBot(value, 2024).then(
                response => {
                    this.totalBeneficios = response.data;
                    // console.log(this.totalBeneficios)
                    // this.$refs.chart.series[0].data = []
                    // for (let index = 0; index < this.totalBeneficios.length; index++) {
                    //     this.$refs.chart.series[0].data.push(this.totalBeneficios[index].beneficios)
                    // }
                    // this.loaded = true
                    // console.log(this.$refs.chart.series[0].data)
                    // this.$refs.chart.updateSeriesLine(this.totalBeneficios)

                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    // EventBus.dispatch("logout");
                }
            );
        }
    },
};
</script>

<style>
table.v-table thead tr {
    color: red !important;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>
